import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const paddings = css`
  padding-left: 32px;
  padding-right: 32px;
`;

const styles = {
  messagesContainer: css`
    display: flex;
    width: 100%;
    flex-direction: column;
  `,
  containerError: css`
    ${paddings}
    background-color: ${COLORS.MESSAGE.ERROR.BACKGROUND};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5px;
    padding-top: 5px;
    min-height: 48px;
    box-shadow: 0 1px 0 0 ${COLORS.MESSAGE.ERROR.SHADOW}, 0 -1px 0 0 ${
    COLORS.MESSAGE.ERROR.SHADOW
  };
  `,
  containerSuccess: css`
    ${paddings}
    background-color: ${COLORS.MESSAGE.SUCCESS.BACKGROUND};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5px;
    padding-top: 5px;
    min-height: 48px;
    box-shadow: 0 1px 0 0 ${COLORS.MESSAGE.SUCCESS.SHADOW}, 0 -1px 0 0 ${
    COLORS.MESSAGE.SUCCESS.SHADOW
  };
  `,
  error: css`
    color: ${COLORS.MESSAGE.ERROR.TEXT};
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
  `,
  success: css`
    color: ${COLORS.MESSAGE.SUCCESS};
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
  `,
  iconContainer: css`
    display: flex;
    width: 15px;
  `
};

export default styles;
